import moment from "moment";

export function getDate(
  type = "now",
  config = { format: "YYYY-MM-DD HH:mm:ss" }
) {
  const { format } = config;
  const obj = {
    // 当前 now
    now: moment().format(format),
    // 前7天 nowTime
    last7: moment().subtract(6, "days").format(format),
    // 前7天 00:00:00
    daySLast7: moment().startOf("day").subtract(6, "days").format(format),
    // 当天开始 00:00:00
    dayS: moment().startOf("day").format(format),
    // 当天结束 23:59:59
    dayE: moment().endOf("day").format(format),
    // 前30天 00:00:00
    daySLast30: moment().startOf("day").subtract(29, "days").format(format),
    // 前90天 00:00:00
    daySLast90: moment().startOf("day").subtract(89, "days").format(format),
  };
  return obj[type];
}

/**
 * Update by  liubaorui on 22/11/14.
 * @desc 添加日期通用函数若干
 */

export const calcDate = (date1, date2) => {
  let date3 = date2 - date1;
  let days = Math.floor(date3 / (24 * 3600 * 1000));
  let leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000));
  let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000));
  let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
  let seconds = Math.round(date3 / 1000);
  return {
    leave1,
    leave2,
    leave3,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  };
};

/**
 * 日期格式化
 */
export function dateFormat(date, format) {
  format = format || "yyyy-MM-dd hh:mm:ss";
  if (date !== "Invalid Date") {
    let o = {
      "M+": date.getMonth() + 1, //month
      "d+": date.getDate(), //day
      "h+": date.getHours(), //hour
      "m+": date.getMinutes(), //minute
      "s+": date.getSeconds(), //second
      "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
      S: date.getMilliseconds(), //millisecond
    };
    if (/(y+)/.test(format))
      format = format.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    for (let k in o)
      if (new RegExp("(" + k + ")").test(format))
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    return format;
  }
  return "";
}

/**
 * 当前时间戳
 */
export function dateNow() {
  return dateFormat(new Date(), "yyyyMMddhhmmss");
}

/**
 * 获取当前日期
 */
export function dayNowFn(type) {
  if (!type || !["now", "start", "end", "nowTime"].includes(type)) {
    type = "now";
  }
  let myDate = new Date();
  let year = myDate.getFullYear();
  let month = myDate.getMonth() + 1;
  let day = myDate.getDate() < 10 ? 0 + myDate.getDate() : myDate.getDate();
  month = month < 10 ? "0" + month : month;
  day = day < 10 ? "0" + day : day;
  const hour = String(myDate.getHours()).padStart(2, "0");
  const minute = String(myDate.getMinutes()).padStart(2, "0");
  const second = String(myDate.getSeconds()).padStart(2, "0");
  switch (type) {
    case "nowTime": {
      // 当前年月日 时分秒
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    }
    case "now": {
      let dayNow = year + "-" + month + "-" + day;
      return dayNow;
    }
    case "start": {
      let dayNow = year + "-" + month + "-" + day + " 00:00:00";
      return dayNow;
    }
    case "end": {
      let dayNow = year + "-" + month + "-" + day + " 23:59:59";
      return dayNow;
    }
  }
}

/**
 * 获取当天日期字符串（yyyy-MM-dd）
 */
export function getTodayDateStr () {
  const date = new Date()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}
/**
 * 获取昨天
 */
export function dayYestFn(type) {
  if (!type || !["start", "end"].includes(type)) {
    type = "start";
  }
  var dayNow = new Date();
  dayNow.setTime(dayNow.getTime() - 24 * 60 * 60 * 1000);
  var s1 =
    dayNow.getFullYear() +
    "-" +
    (dayNow.getMonth() + 1) +
    "-" +
    dayNow.getDate();
  switch (type) {
    case "start": {
      let dayYest = s1 + " 00:00:00";
      return dayYest;
    }
    case "end": {
      let dayYest = s1 + +" 23:59:59";
      return dayYest;
    }
  }
}

/**
 * 获取当前月份
 */
export function getNowMonth() {
  let myDate = new Date();
  let year = myDate.getFullYear();
  let month = myDate.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let nowMonth = year + "-" + month;
  return nowMonth;
}

// 获取当月第一天0点0时0秒
export function getMonthStartTime() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const firstDay = new Date(year, month, 1);
  return formatDateTime(firstDay);
}

// 获取当天23点59分59秒
export function getTodayEndTime() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();
  const todayEnd = new Date(year, month, day, 23, 59, 59);
  return formatDateTime(todayEnd);
}

// 格式化日期时间
export function formatDateTime(date) {
  if (!date) return "-";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "-";
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const seconds = String(d.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 *  利用间隔天数获取日期
 *
 * @param dateNow :Date类
 * @param intervalDays ：间隔天数
 * @param bolPastTime  ：Boolean,判断在参数date之前，还是之后，
 */
export function getDateRange(dateNow, intervalDays, bolPastTime) {
  let oneDayTime = 24 * 60 * 60 * 1000;
  let list = [];
  let lastDay;

  if (bolPastTime == true) {
    lastDay = new Date(dateNow.getTime() - intervalDays * oneDayTime);
    list.push(formateDate(lastDay));
    list.push(formateDate(dateNow));
  } else {
    lastDay = new Date(dateNow.getTime() + intervalDays * oneDayTime);
    list.push(formateDate(dateNow));
    list.push(formateDate(lastDay));
  }
  return list;
}
export function formateDate(time) {
  let year = time.getFullYear();
  let month = time.getMonth() + 1;
  let day = time.getDate();

  if (month < 10) {
    month = "0" + month;
  }

  if (day < 10) {
    day = "0" + day;
  }

  return year + "-" + month + "-" + day + "";
}

/**
 * 获取当前月份第一天
 */
export function getCurrentMonthFirst() {
  let date = new Date();
  date.setDate(1);
  let months = parseInt(date.getMonth() + 1);
  let days = date.getDate();
  if (months < 10) {
    months = "0" + months;
  }
  if (days < 10) {
    days = "0" + days;
  }
  let datas = date.getFullYear() + "-" + months + "-" + days;
  return datas;
}

/**
 * 当月最后一天
 */
export function getCurrentMonthEnd() {
  let date = new Date();
  date.setDate(1);
  let months = parseInt(date.getMonth() + 1);
  let days = new Date(
    date.getFullYear(),
    new Date().getMonth() + 1,
    0
  ).getDate();
  if (months < 10) {
    months = "0" + months;
  }
  if (days < 10) {
    days = "0" + days;
  }
  let datas = date.getFullYear() + "-" + months + "-" + days;
  return datas;
}

/* 获取本周时间段 */
export function getCurrentWeek(value = null, separate = "-") {
  // 如果为null,则格式化当前时间
  if (!value) value = Number(new Date());
  // 如果dateTime长度为10或者13，则为秒和毫秒的时间戳，如果超过13位，则为其他的时间格式
  if (value.toString().length === 10) value *= 1000;
  value = +new Date(Number(value));

  const oneDay = 86400000; // 24 * 60 * 60 * 1000;
  const weekDate = new Date(value);
  const day = weekDate.getDay() === 0 ? 7 : weekDate.getDay(); // 返回1-7,7表示周日
  // 设置时间为当天的0点
  weekDate.setHours(0, 0, 0, 0);
  // 算出本周开始时间结束时间
  const weekStartTime = new Date(weekDate.getTime() - (day - 1) * oneDay);
  const weekEndTime = new Date(weekDate.getTime() + (7 - day) * oneDay);

  // 格式化日期
  const filters = (n) => {
    return n < 10 ? (n = `0${n}`) : n;
  };
  const startmonth = filters(weekStartTime.getMonth() + 1);
  const startDay = filters(weekStartTime.getDate());
  const endmonth = filters(weekEndTime.getMonth() + 1);
  const endDay = filters(weekEndTime.getDate());

  const startDateTime =
    weekStartTime.getFullYear() + separate + startmonth + separate + startDay;
  const endDateTime =
    weekEndTime.getFullYear() + separate + endmonth + separate + endDay;
  return `${startDateTime} 00:00:00` + "," + `${endDateTime} 23:59:59`;
}
/**
 * 根据传入参数获取日期()
 * @param dayCount  获取之后日期传正数，之前日期传负数
 * @returns {string}  日期
 */
export function getDateByParam(dayCount) {
  let tomorrow = new Date();
  tomorrow.setTime(tomorrow.getTime() + dayCount * (24 * 60 * 60 * 1000));
  let Month = tomorrow.getMonth() + 1;
  let day = tomorrow.getDate();
  Month = Month < 10 ? "0" + Month : Month;
  day = day < 10 ? "0" + day : day;
  return tomorrow.getFullYear() + "-" + Month + "-" + day;
}
/**
 * 根据传入参数获取日期()
 * @param dayCount  获取之后日期传正数，之前日期传负数
 * @returns {string}  日期
 */
export function getDateTimeByParam(dayCount, type) {
  if (!type || !["start", "end"].includes(type)) {
    type = "start";
  }
  let tomorrow = new Date();
  tomorrow.setTime(tomorrow.getTime() + dayCount * (24 * 60 * 60 * 1000));
  let Month = tomorrow.getMonth() + 1;
  let day = tomorrow.getDate();
  Month = Month < 10 ? "0" + Month : Month;
  day = day < 10 ? "0" + day : day;
  switch (type) {
    case "start": {
      return tomorrow.getFullYear() + "-" + Month + "-" + day + " 00:00:00";
    }
    case "end": {
      return tomorrow.getFullYear() + "-" + Month + "-" + day + " 23:59:59";
    }
  }
}

/**
 * 获取当天00:00:00点到23:59:59
 */
export function getAllDayNowFn() {
  let myDate = new Date();
  let year = myDate.getFullYear();
  let month = myDate.getMonth() + 1;
  let day = myDate.getDate() < 10 ? 0 + myDate.getDate() : myDate.getDate();
  month = month < 10 ? "0" + month : month;
  day = day < 10 ? "0" + day : day;
  let dayNow =
    year +
    "-" +
    month +
    "-" +
    day +
    " 00:00:00" +
    "," +
    year +
    "-" +
    month +
    "-" +
    day +
    " 23:59:59";
  return dayNow;
}

/**
 * 获取日历字符串
 */
export function currentDate(that, targetTime) {
  setInterval(() => {
    setTimeout(() => {
      let date1 = new Date();
      let year = date1.getFullYear();
      let month = date1.getMonth();
      let day = date1.getDate();
      let xinqi = date1.getDay();
      let hh = date1.getHours();
      let mm = date1.getMinutes();
      let ss = date1.getSeconds();
      that[targetTime] = `${year}年${month + 1}月${day}日  ${
        hh < 10 ? "0" + hh : hh
      }:${mm < 10 ? "0" + mm : mm}:${
        ss < 10 ? "0" + ss : ss
      }   星期${getChineseNum(xinqi)}`;
    }, 0);
  }, 1000);
}
const getChineseNum = function (num) {
  let nums = "";
  switch (num) {
    case 1:
      nums = "一";
      break;
    case 2:
      nums = "二";
      break;
    case 3:
      nums = "三";
      break;
    case 4:
      nums = "四";
      break;
    case 5:
      nums = "五";
      break;
    case 6:
      nums = "六";
      break;
    case 0:
      nums = "日";
      break;
  }
  return nums;
};

// ===================== 列表或其他默认值 统一组合式调用 =============================
//获取7天前至今日 + 当月 + 近30天 + 当日 + 当日时间段
export function getAllWeekBeforeNowFn(type = "week") {
  // 健壮处理
  if (
    !type ||
    !["week", "weekStart", "month", "day", "today", "monthRecent"].includes(
      type
    )
  ) {
    type = "week";
  }
  // 月
  if (type == "month") {
    return (
      getCurrentMonthFirst() +
      " 00:00:00" +
      "," +
      getCurrentMonthEnd() +
      " 23:59:59"
    );
  }
  // 近三十天
  else if (type == "monthRecent") {
    return (
      getDateRange(new Date(), 30, true)[0] +
      "," +
      getDateRange(new Date(), 30, true)[1]
    );
  }
  // 近一周
  else if (type == "week") {
    let myDate = new Date();
    let year = myDate.getFullYear();
    let month = myDate.getMonth() + 1;
    let day = myDate.getDate() < 10 ? 0 + myDate.getDate() : myDate.getDate();
    month = month < 10 ? "0" + month : month;
    day = day < 10 ? "0" + day : day;
    let dayNow =
      getDateByParam(-6) +
      " 00:00:00" +
      "," +
      year +
      "-" +
      month +
      "-" +
      day +
      " 23:59:59";
    return dayNow;
  } else if (type == "weekStart") {
    let dayNow = getDateByParam(-6) + " 00:00:00";
    return dayNow;
  }
  // 今日范围
  else if (type == "day") {
    return getAllDayNowFn();
  }
  // 今天
  else if (type == "today") {
    return dayNowFn();
  }
}

// 获取当前时间减去指定分钟数后的时间
export function getTimeMinusMinutes(minutes = 30) {
  if (typeof minutes !== "number" || isNaN(minutes) || minutes < 0) {
    // 如果传入的不是有效数字或小于0，则默认为30分钟
    minutes = 30;
  }
  const now = new Date();
  // 从当前时间中减去指定的分钟数
  now.setMinutes(now.getMinutes() - minutes);
  // 获取年、月、日、时、分、秒，并补零
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的，所以加1
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  const second = String(now.getSeconds()).padStart(2, "0");
  // 返回格式化的时间字符串
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}
// ================================== END =========================================

/**
 * @param {string} type - 时间类型标识符
 * @param {Object} config - 配置对象
 * @param {string} config.format - 时间格式字符串
 * @param {number} config.num - 自定义增加时间数，可为负
 * @param {string} [config.unit='days'] - 自定义增加时间单位(days/hours/minutes等)
 */
export function getSettingDate(type = "now", config = {}) {
  const {
    format,
    unit = "days",
    num,
  } = { ...config, format: config.format || "YYYY-MM-DD HH:mm:ss" };
  const now = moment();
  const todayStart = now.clone().startOf("day");
  const todayEnd = now.clone().endOf("day");

  const DATE_MAP = {
    // 当前时间
    now: now.format(format),
    // 7天前（含今天共7天）
    last7: now.clone().subtract(6, "days").format(format),
    // 7天前的00:00:00
    daySLast7: todayStart.clone().subtract(6, "days").format(format),
    // 当天开始时间
    dayS: todayStart.format(format),
    // 当天结束时间
    dayE: todayEnd.format(format),
    // 30天前的00:00:00
    daySLast30: todayStart.clone().subtract(29, "days").format(format),
    // 90天前的00:00:00（与 `searchTimeConfig` 快捷「最近三个月」一致）
    daySLast90: todayStart.clone().subtract(89, "days").format(format),
    // 本月开始时间
    monthStart: now.clone().startOf("month").format(format),
    // 本月结束时间
    monthEnd: now.clone().endOf("month").format(format),
    // 获取自定义时间
    customTime: now.clone().add(num, unit).format(format),
  };

  return DATE_MAP[type] || now.format(format);
}
